import { whyAAITData } from "@/mocks/landingData";

export default function WhyAAIT() {
  return (
    <section className="section-padding relative">
      <div className="container-main">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="v2-section-label">
              <span className="w-8 h-px bg-teal-400" />
              لماذا نحن
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mt-4 mb-6">
              <span className="title-line-1">لماذا</span>
              <span className="title-line-2 v2-gradient-text">
                أوامر الشبكة؟
              </span>
            </h2>
            <p className="text-slate-400 leading-relaxed text-base md:text-lg mb-10">
              نحن نؤمن بأن النجاح الرقمي يبدأ بشراكة حقيقية. فريقنا يجمع بين
              الخبرة التقنية والفهم العميق للسوق السعودي لتقديم حلول تُحدث
              فرقًا.
            </p>

            <div className="grid sm:grid-cols-2 gap-4">
              {whyAAITData.map((item) => (
                <div
                  key={item.title}
                  className="v2-glass-card p-5 hover:border-teal-400/30 transition-all group"
                >
                  <div className="w-10 h-10 rounded-xl bg-teal-500/10 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                    <i className={`${item.icon} text-teal-400 text-lg`} />
                  </div>
                  <h4 className="font-bold text-white mb-1 text-sm">
                    {item.title}
                  </h4>
                  <p className="text-xs text-slate-400 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative max-w-full overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-teal-500/15 to-transparent rounded-3xl blur-3xl pointer-events-none" />
            <div className="relative v2-glass-card p-2 rounded-3xl">
              <img
                src="/images/why-team.jpg"
                alt="فريق أوامر الشبكة"
                className="w-full aspect-[7/5] object-cover rounded-2xl"
                loading="lazy"
              />
            </div>
            <div className="absolute bottom-2 left-2 sm:-bottom-6 sm:-left-6 bg-gradient-to-br from-teal-500 to-aait-primary text-white rounded-2xl p-6 shadow-[0_0_40px_-10px_rgba(45,212,191,0.5)]">
              <div className="text-4xl font-extrabold">+20</div>
              <div className="text-sm text-white/80 mt-1">عامًا من الخبرة</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
